export const defensiveScoreCategories = [
  'major',
  'minor',
  'group',
  'buff',
] as const

type DefensiveScoreCategory = typeof defensiveScoreCategories[number]

export const defensiveScoreCategoryLabels: Record<
  DefensiveScoreCategory,
  string
> = {
  major: 'Major',
  minor: 'Minor',
  group: 'Group',
  buff: 'Buff',
}

export default DefensiveScoreCategory
